import React, {useState} from "react"
import PartThreeIntro from "./PartThreeIntro"
import SearchButtons from "./SearchButtons"
import Bookcase from "./Bookcase"
import Painting from "./Painting"
import Desk from "./Desk"
import DeskReward from "./DeskReward"
import Safe from "./Safe"
import SafeReward from "./SafeReward"

function PartThree(props) {
    const [puzzleCompleted, setPuzzleCompleted] = useState({
        desk: false,
        painting: false,
        safe: false
    })
    const [view, setView] = useState(0)
    
    if (props.partStatus === "complete" && !puzzleCompleted.desk) {
        setPuzzleCompleted({
            desk: true,
            painting: true,
            safe: true
        })
    }
    
    function updateCompleted(puzzle, update) {
        setPuzzleCompleted({
            ...puzzleCompleted,
            [puzzle]: update
        })
    }
    
     function handleClick(event) {
        const {name, value} = event.target
        if (name === "reveal safe" && puzzleCompleted.desk) {
            setPuzzleCompleted({
                ...puzzleCompleted,
                painting: true
            })
            props.callBackRevealClues("Unlocking The Safe", "The Painting")
        } else if (name !== "reveal safe") {
            setView(value)
        }
    }
    
    const deskStatus = puzzleCompleted.desk ? <DeskReward /> : <Desk callBack={props.callBack} callBackCompleted={updateCompleted} callBackRevealClues={props.callBackRevealClues}/>
    
    const roomViews = [
        <PartThreeIntro />,
        <Bookcase />,
        deskStatus,
        <Painting handleClick={handleClick} />,
    ]
    
    const roomSearch = 
        <div className="roomSearchWrapper">
            {roomViews[view]}
            <SearchButtons handleClick={handleClick} />
        </div>
    
    const safeStatus = puzzleCompleted.safe ? <SafeReward /> : <Safe callBack={props.callBack} callBackCompleted={updateCompleted} callBackRevealClues={props.callBackRevealClues}/>
    
    const paintingStatus = puzzleCompleted.painting ? safeStatus : roomSearch
    
    return (
        <div className="searchAndSafeWrapper">
            {paintingStatus} 
        </div>
    )
}

export default PartThree